let currentTitle = 'GotU';

export function updateTitle(newTitle) {
  if (typeof newTitle !== 'undefined') {
    currentTitle = newTitle;
  }
  document.title = currentTitle;
  window.history.replaceState({}, document.title, document.location.href);
}

export function updateFavicon(newFaviconUrl) {
  let iconNode = document.querySelector('head link[rel=icon]');
  if (!iconNode) {
    iconNode = document.createElement('link');
    iconNode.rel = 'icon';
    iconNode.type = 'image/x-icon';
    document.querySelector('head').appendChild(iconNode);
  }

  iconNode.href = newFaviconUrl;
}



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/dom.js